import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  locationId: null,
  ghlToken: null,
  isAuthenticated: false,
  error: null,
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      // Handle both login and verify responses
      if (action.payload.user) {
        state.user = action.payload.user;
        state.locationId = action.payload.user.locationId;
        state.ghlToken = action.payload.user.ghlToken;
      } else {
        state.locationId = action.payload.locationId;
        state.ghlToken = action.payload.ghlToken;
      }
      state.isAuthenticated = true;
      state.error = null;
    },
    logout: (state) => {
      state.locationId = null;
      state.ghlToken = null;
      state.isAuthenticated = false;
      state.error = null;
      state.user = null;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setCredentials, logout, setError } = authSlice.actions;
export default authSlice.reducer; 